module.exports = __webpack_public_path__ + "media/images/mineco-fbc3a3204f9c9d78649623fab0ed05ee.png";